import React, { useState } from 'react';
import { UserIcon, MailIcon, LockIcon } from 'lucide-react';
interface LoginPageProps {
  onLogin: (role: string) => void;
}
const LoginPage: React.FC<LoginPageProps> = ({
  onLogin
}) => {
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('student');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // In a real app, you would validate and authenticate here
    onLogin(role);
  };
  return <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4" data-id="element-588">
      <div className="bg-white rounded-xl shadow-xl overflow-hidden max-w-md w-full" data-id="element-589">
        <div className="bg-blue-600 p-6 text-white text-center" data-id="element-590">
          <h1 className="text-2xl font-bold" data-id="element-591">学习目标打卡</h1>
          <p className="mt-1 text-blue-100" data-id="element-592">成就激励系统</p>
        </div>
        <div className="p-8" data-id="element-593">
          <h2 className="text-2xl font-bold text-center text-gray-800 mb-6" data-id="element-594">
            {isLogin ? '欢迎回来' : '创建新账户'}
          </h2>
          <form onSubmit={handleSubmit} data-id="element-595">
            {!isLogin && <div className="mb-4" data-id="element-596">
                <label className="block text-gray-700 text-sm font-medium mb-2" htmlFor="name" data-id="element-597">
                  姓名
                </label>
                <div className="relative" data-id="element-598">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-599">
                    <UserIcon size={18} className="text-gray-400" data-id="element-600" />
                  </div>
                  <input id="name" type="text" className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" placeholder="请输入你的姓名" data-id="element-601" />
                </div>
              </div>}
            <div className="mb-4" data-id="element-602">
              <label className="block text-gray-700 text-sm font-medium mb-2" htmlFor="email" data-id="element-603">
                邮箱
              </label>
              <div className="relative" data-id="element-604">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-605">
                  <MailIcon size={18} className="text-gray-400" data-id="element-606" />
                </div>
                <input id="email" type="email" className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" placeholder="请输入你的邮箱" value={email} onChange={e => setEmail(e.target.value)} data-id="element-607" />
              </div>
            </div>
            <div className="mb-4" data-id="element-608">
              <label className="block text-gray-700 text-sm font-medium mb-2" htmlFor="password" data-id="element-609">
                密码
              </label>
              <div className="relative" data-id="element-610">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-611">
                  <LockIcon size={18} className="text-gray-400" data-id="element-612" />
                </div>
                <input id="password" type="password" className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" placeholder="请输入你的密码" value={password} onChange={e => setPassword(e.target.value)} data-id="element-613" />
              </div>
            </div>
            <div className="mb-6" data-id="element-614">
              <label className="block text-gray-700 text-sm font-medium mb-2" data-id="element-615">
                身份
              </label>
              <div className="flex space-x-4" data-id="element-616">
                <label className="inline-flex items-center" data-id="element-617">
                  <input type="radio" className="form-radio text-blue-600" name="role" value="student" checked={role === 'student'} onChange={() => setRole('student')} data-id="element-618" />
                  <span className="ml-2" data-id="element-619">学生</span>
                </label>
                <label className="inline-flex items-center" data-id="element-620">
                  <input type="radio" className="form-radio text-blue-600" name="role" value="teacher" checked={role === 'teacher'} onChange={() => setRole('teacher')} data-id="element-621" />
                  <span className="ml-2" data-id="element-622">老师</span>
                </label>
              </div>
            </div>
            <button type="submit" className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2" data-id="element-623">
              {isLogin ? '登录' : '注册'}
            </button>
          </form>
          <div className="mt-6 text-center" data-id="element-624">
            <button className="text-blue-600 hover:text-blue-800 text-sm font-medium" onClick={() => setIsLogin(!isLogin)} data-id="element-625">
              {isLogin ? '没有账号？点击注册' : '已有账号？点击登录'}
            </button>
          </div>
        </div>
      </div>
    </div>;
};
export default LoginPage;